// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DashboardCards-dashboardCardContainer-ZMusb {
  background: var(--background-primary);
  padding: 24px;
  border-radius: var(--radius-3);
}

.DashboardCards-dashboardCardTitle-TViJP {
  font-size: 16px;
  font-weight: 700;
  line-height: 26px;
  color: var(--primary-foreground);
  margin-bottom: 12px;
  text-align: start;
}

.DashboardCards-dashboardCardSubWrapper-WQ3Su {
  padding: 18px;
  background: var(--background-secondary);
  border-radius: var(--radius-3);
}

.DashboardCards-dashboardCardSubImgContainer-QULxh {
  width: 63px;
  height: 63px;
  border-radius: 50%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  margin-bottom: 12px;
}

.DashboardCards-dashboardCardSubContent-xou21 {
  font-size: 14px;
  line-height: 24px;
  font-weight: 400;
  color: var(--primary-foreground);
  margin-bottom: 6px;
  text-align: start;
}

@media (max-width: 767px) {
  .DashboardCards-dashboardCardContainer-ZMusb {
    padding: 18px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/DashboardCards/DashboardCards.css"],"names":[],"mappings":"AAAA;EACE,qCAAqC;EACrC,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gCAAgC;EAChC,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uCAAuC;EACvC,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":[".dashboardCardContainer {\n  background: var(--background-primary);\n  padding: 24px;\n  border-radius: var(--radius-3);\n}\n\n.dashboardCardTitle {\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 26px;\n  color: var(--primary-foreground);\n  margin-bottom: 12px;\n  text-align: start;\n}\n\n.dashboardCardSubWrapper {\n  padding: 18px;\n  background: var(--background-secondary);\n  border-radius: var(--radius-3);\n}\n\n.dashboardCardSubImgContainer {\n  width: 63px;\n  height: 63px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 12px;\n}\n\n.dashboardCardSubContent {\n  font-size: 14px;\n  line-height: 24px;\n  font-weight: 400;\n  color: var(--primary-foreground);\n  margin-bottom: 6px;\n  text-align: start;\n}\n\n@media (max-width: 767px) {\n  .dashboardCardContainer {\n    padding: 18px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dashboardCardContainer": `DashboardCards-dashboardCardContainer-ZMusb`,
	"dashboardCardTitle": `DashboardCards-dashboardCardTitle-TViJP`,
	"dashboardCardSubWrapper": `DashboardCards-dashboardCardSubWrapper-WQ3Su`,
	"dashboardCardSubImgContainer": `DashboardCards-dashboardCardSubImgContainer-QULxh`,
	"dashboardCardSubContent": `DashboardCards-dashboardCardSubContent-xou21`
};
module.exports = ___CSS_LOADER_EXPORT___;
